import $http from '@/api';
import store from '@/store';

export default {
  /**
   * Fetches an url by its path.
   * @param path
   * @param siteId
   * @return {Promise<{} | null>}
   */
  async fetchUrl(path, siteId = store.getters.siteId) {
    const response = await this.searchUrl({ path, siteId });
    if (response.results
      && response.results.length) {
      return response.results[0];
    }
    return null;
  },

  /**
   * Search urls by the given filters.
   * @param filters
   * @param source
   * @return {Promise<T | {canceled: boolean, results: Array}>}
   */
  async searchUrl(filters = {}, source = {}) {
    if (!filters.siteId) {
      filters.siteId = store.getters.siteId;
      console.warn('Url search: Missing mandatory filter `siteId`. Using current site to filter the results', filters.siteId);
    }
    return $http.post('/api/url/search', filters, { cancelToken: source.token })
      .catch((e) => {
        console.log('Search exception:', e);
        return { canceled: true, results: [] };
      });
  },

  /**
   * Returns whether an URL with the given path exists.
   * @param path
   * @param siteId
   * @return {Promise<boolean>}
   */
  async isUnique(path, siteId = store.getters.siteId) {
    const url = await this.fetchUrl(path, siteId);
    return Boolean(url === null);
  },

  async suggest(filters = {}, source = {}) {
    if (!filters.siteId) {
      filters.siteId = store.getters.siteId;
      console.warn('Url search: Missing mandatory filter `siteId`. Using current site to filter the results', filters.siteId);
    }
    return $http.post('/api/url/suggest', filters, { cancelToken: source.token })
      .catch(e => ({ canceled: true, results: [] }));
  },
};
